import React, { useRef, useEffect } from 'react'
import gsap from 'gsap';

export default function HelloLoading() {
    const wrapper = useRef(null);

    useEffect( () => {
        const [...elements] = wrapper.current.children ;
        const tl = gsap.timeline({defaults: { ease: 'power3.inOut'}});

        tl.to(elements[0], {
            duration: .7,
            top: "-100%",
          })
        .to(elements[1], {
            duration: .7,
            top: "-100%"
          }, "-=0.5")
        .to(elements[2], {
            duration: .7,
            top: "-100%"
          }, "-=0.5")

    }, [])

    return (
        <div className="overlay__container" ref={wrapper}>
            <div className="overlay overlay--first"></div>
            <div className="overlay overlay--second"></div>
            <div className="overlay overlay--third"></div>
        </div>
    )
}